import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {alertTypes, useAlerts} from '../ui/alert';
import {
  equiposGetDuck,
  equiposGetThunk,
  equipoDeleteDuck,
  equipoDeleteThunk,
} from './duck';
import {constants, responseSelector} from '../utils/utils';
import {EquiposListView} from './EquiposListView';
import {useQueryParams} from '../utils/useQueryParams';

const queryString = require('query-string');

export const EquiposList = ({history, token}) => {
  const {queryParams, queryParamsloaded} = useQueryParams(history);

  const dispatch = useDispatch();

  const equiposGet = useSelector(state => state.equiposGet);

  const equipoDelete = useSelector(state => state.equipoDelete);

  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalResults, setTotalResults] = useState(0);
  const [lista, setLista] = useState(null);
  const [selectedEquipo, setSelectedEquipo] = useState();
  const [isDeleteConfirmModalShown, setIsDeleteConfirmModalShown] =
    useState(false);

  const [busquedaRapida, setBusquedaRapida] = useState('');

  const {submitAlert, setTopAlert, topAlert} = useAlerts();

  const _getFiltersFromQueryParams = queryParams => {
    const page = Number(queryParams?.page ?? 1);
    const busquedaRapida = queryParams?.busquedaRapida ?? '';

    return {
      busquedaRapida,
      page,
    };
  };

  const getEquipos = filters => {
    if (!filters) {
      throw new Error('No filters received');
    }

    dispatch(
      equiposGetThunk({
        userToken: token.raw,
        limit: pageSize,
        page: filters.page,
        busquedaRapida: filters.busquedaRapida,
      }),
    );
  };

  useEffect(() => {
    if (!queryParamsloaded) return;

    const filters = _getFiltersFromQueryParams(queryParams);

    setPage(filters.page);
    setBusquedaRapida(filters.busquedaRapida);

    setFilters(filters);
    getEquipos(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, queryParamsloaded]);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(equiposGet);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(equiposGetDuck.actions.clear());
    }

    if (data) {
      setTotalResults(data.count);
      setLista(data.items);

      dispatch(equiposGetDuck.actions.clear());
    }
  }, [equiposGet]);

  useEffect(() => {
    const {httpStatus, error, errorMessage} = responseSelector(equipoDelete);

    if (error) {
      const errorAlert = {
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      };
      setTopAlert(errorAlert);

      setIsDeleteConfirmModalShown(false);

      dispatch(equipoDeleteDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      handlePage(1);

      setTopAlert({
        text: 'Equipo eliminado',
        type: alertTypes.success,
        closable: false,
      });

      setIsDeleteConfirmModalShown(false);
      dispatch(equipoDeleteDuck.actions.clear());
    }
  }, [equipoDelete]);

  const handlePage = page => {

    const strNewParams = queryString.stringify({
      page,
      busquedaRapida,
    });

    history.replace(`${history.location.pathname}?${strNewParams}`);
  };

  const doDeleteEquipo = () => {
    dispatch(
      equipoDeleteThunk({
        userToken: token.raw,
        idNumerico: selectedEquipo?.idNumerico,
      }),
    );
  };

  return (
    <EquiposListView
      history={history}
      topAlert={topAlert}
      submitAlert={submitAlert}
      totalResults={totalResults}
      page={page}
      pageSize={pageSize}
      handlePage={handlePage}
      lista={lista}
      busquedaRapida={busquedaRapida}
      setBusquedaRapida={setBusquedaRapida}
      equiposGet={equiposGet}
      doDeleteEquipo={doDeleteEquipo}
      equipoDelete={equipoDelete}
      selectedEquipo={selectedEquipo}
      setSelectedEquipo={setSelectedEquipo}
      isDeleteConfirmModalShown={isDeleteConfirmModalShown}
      setIsDeleteConfirmModalShown={setIsDeleteConfirmModalShown}
    />
  );
};
